<template>
  <div class="text-darkBlue">
    <div class="flex items-center justify-between mt-2">
      <page-header
        heading="Tracking Shipments"
        breadcrumb="Booking & Shipments >> Tracking Shipments"
      />
      <search-filter />
    </div>

    <div class="mt-24 tracks">
      <div class="relative">
        <div class="shipment-track flex justify-between items-center">
          <div>
            <p>Date</p>
          </div>
          <div class="text-center">
            <p class="text-2xl font-bold">Delivered</p>
            <p class="text-sm">Delivery made</p>
          </div>
          <div>
            <svg
              width="49"
              height="32"
              viewBox="0 0 49 32"
              fill="none"
              xmlns="http://www.w3.org/2000/svg"
            >
              <path
                d="M49 4.1875C49 3.14321 48.516 2.14169 47.6545 1.40327C46.793 0.664843 45.6246 0.25 44.4062 0.25H16.8438C15.6254 0.25 14.457 0.664843 13.5955 1.40327C12.734 2.14169 12.25 3.14321 12.25 4.1875V8.125H9.12625C8.43798 8.12553 7.75866 8.25861 7.13846 8.51441C6.51827 8.77021 5.97306 9.1422 5.54313 9.60288L1.00756 14.4591C0.354977 15.1579 -0.000404358 16.0263 0 16.9214V22.5625C0 23.6068 0.483982 24.6083 1.34548 25.3467C2.20697 26.0852 3.37541 26.5 4.59375 26.5H6.125C6.125 27.8924 6.77031 29.2277 7.91897 30.2123C9.06763 31.1969 10.6255 31.75 12.25 31.75C13.8745 31.75 15.4324 31.1969 16.581 30.2123C17.7297 29.2277 18.375 27.8924 18.375 26.5H33.6875C33.6857 27.1998 33.8472 27.8928 34.1624 28.5383C34.4776 29.1839 34.9402 29.7688 35.523 30.2589C36.1058 30.749 36.797 31.1343 37.556 31.3921C38.315 31.6499 39.1264 31.775 39.9427 31.7601C40.7589 31.7453 41.5634 31.5907 42.309 31.3055C43.0545 31.0202 43.726 30.6101 44.2839 30.0993C44.8419 29.5884 45.275 28.9871 45.558 28.3307C45.8409 27.6742 45.9678 26.976 45.9314 26.2769C46.8285 26.0062 47.6056 25.5035 48.1552 24.8382C48.7049 24.1729 49.0001 23.3777 49 22.5625V4.1875ZM45.0371 23.7595C44.4834 22.9825 43.7034 22.3423 42.7736 21.902C41.8439 21.4616 40.7965 21.2361 39.7343 21.2478C38.6722 21.2594 37.6318 21.5078 36.7155 21.9684C35.7993 22.429 35.0386 23.0861 34.5083 23.875H17.5543C17.0155 23.0777 16.2427 22.4152 15.3125 21.9535V4.1875C15.3125 3.8394 15.4738 3.50556 15.761 3.25942C16.0482 3.01328 16.4376 2.875 16.8438 2.875H44.4062C44.8124 2.875 45.2018 3.01328 45.489 3.25942C45.7762 3.50556 45.9375 3.8394 45.9375 4.1875V22.5625C45.9377 22.8151 45.8529 23.0625 45.6932 23.2748C45.5335 23.4871 45.3057 23.6554 45.0371 23.7595ZM12.25 21.25C11.1749 21.25 10.1187 21.4926 9.18759 21.9534C8.2565 22.4142 7.48332 23.0769 6.94575 23.875H4.59375C4.18764 23.875 3.79816 23.7367 3.51099 23.4906C3.22383 23.2444 3.0625 22.9106 3.0625 22.5625V16.9188C3.06312 16.6209 3.18192 16.3321 3.39937 16.0998L7.93188 11.2435C8.07508 11.0898 8.25678 10.9656 8.46352 10.8802C8.67025 10.7948 8.89674 10.7503 9.12625 10.75H12.25V21.25ZM39.8125 23.875C40.6247 23.875 41.4037 24.1516 41.978 24.6438C42.5523 25.1361 42.875 25.8038 42.875 26.5C42.875 27.1962 42.5523 27.8639 41.978 28.3562C41.4037 28.8484 40.6247 29.125 39.8125 29.125C39.0003 29.125 38.2213 28.8484 37.647 28.3562C37.0727 27.8639 36.75 27.1962 36.75 26.5C36.75 25.8038 37.0727 25.1361 37.647 24.6438C38.2213 24.1516 39.0003 23.875 39.8125 23.875ZM12.25 23.875C13.0622 23.875 13.8412 24.1516 14.4155 24.6438C14.9898 25.1361 15.3125 25.8038 15.3125 26.5C15.3125 27.1962 14.9898 27.8639 14.4155 28.3562C13.8412 28.8484 13.0622 29.125 12.25 29.125C11.4378 29.125 10.6588 28.8484 10.0845 28.3562C9.51015 27.8639 9.1875 27.1962 9.1875 26.5C9.1875 25.8038 9.51015 25.1361 10.0845 24.6438C10.6588 24.1516 11.4378 23.875 12.25 23.875Z"
                fill="#FFA600"
              />
            </svg>
          </div>
        </div>

        <div class="track-sign">
          <svg
            width="24"
            height="24"
            viewBox="0 0 24 24"
            fill="none"
            xmlns="http://www.w3.org/2000/svg"
          >
            <circle
              cx="12"
              cy="12"
              r="11"
              transform="rotate(-90 12 12)"
              fill="white"
              stroke="#959CB6"
              stroke-width="2"
            />
            <circle
              cx="12"
              cy="12"
              r="6.5"
              transform="rotate(-90 12 12)"
              fill="white"
              stroke="#959CB6"
            />
          </svg>
        </div>
      </div>
      <div class="relative">
        <div class="shipment-track flex justify-between items-center">
          <div>
            <p>Date</p>
          </div>
          <div class="text-center">
            <p class="text-2xl font-bold">In Transit</p>
            <p class="text-sm">In Transit</p>
          </div>
          <div>
            <svg
              width="49"
              height="32"
              viewBox="0 0 49 32"
              fill="none"
              xmlns="http://www.w3.org/2000/svg"
            >
              <path
                d="M49 4.1875C49 3.14321 48.516 2.14169 47.6545 1.40327C46.793 0.664843 45.6246 0.25 44.4062 0.25H16.8438C15.6254 0.25 14.457 0.664843 13.5955 1.40327C12.734 2.14169 12.25 3.14321 12.25 4.1875V8.125H9.12625C8.43798 8.12553 7.75866 8.25861 7.13846 8.51441C6.51827 8.77021 5.97306 9.1422 5.54313 9.60288L1.00756 14.4591C0.354977 15.1579 -0.000404358 16.0263 0 16.9214V22.5625C0 23.6068 0.483982 24.6083 1.34548 25.3467C2.20697 26.0852 3.37541 26.5 4.59375 26.5H6.125C6.125 27.8924 6.77031 29.2277 7.91897 30.2123C9.06763 31.1969 10.6255 31.75 12.25 31.75C13.8745 31.75 15.4324 31.1969 16.581 30.2123C17.7297 29.2277 18.375 27.8924 18.375 26.5H33.6875C33.6857 27.1998 33.8472 27.8928 34.1624 28.5383C34.4776 29.1839 34.9402 29.7688 35.523 30.2589C36.1058 30.749 36.797 31.1343 37.556 31.3921C38.315 31.6499 39.1264 31.775 39.9427 31.7601C40.7589 31.7453 41.5634 31.5907 42.309 31.3055C43.0545 31.0202 43.726 30.6101 44.2839 30.0993C44.8419 29.5884 45.275 28.9871 45.558 28.3307C45.8409 27.6742 45.9678 26.976 45.9314 26.2769C46.8285 26.0062 47.6056 25.5035 48.1552 24.8382C48.7049 24.1729 49.0001 23.3777 49 22.5625V4.1875ZM45.0371 23.7595C44.4834 22.9825 43.7034 22.3423 42.7736 21.902C41.8439 21.4616 40.7965 21.2361 39.7343 21.2478C38.6722 21.2594 37.6318 21.5078 36.7155 21.9684C35.7993 22.429 35.0386 23.0861 34.5083 23.875H17.5543C17.0155 23.0777 16.2427 22.4152 15.3125 21.9535V4.1875C15.3125 3.8394 15.4738 3.50556 15.761 3.25942C16.0482 3.01328 16.4376 2.875 16.8438 2.875H44.4062C44.8124 2.875 45.2018 3.01328 45.489 3.25942C45.7762 3.50556 45.9375 3.8394 45.9375 4.1875V22.5625C45.9377 22.8151 45.8529 23.0625 45.6932 23.2748C45.5335 23.4871 45.3057 23.6554 45.0371 23.7595ZM12.25 21.25C11.1749 21.25 10.1187 21.4926 9.18759 21.9534C8.2565 22.4142 7.48332 23.0769 6.94575 23.875H4.59375C4.18764 23.875 3.79816 23.7367 3.51099 23.4906C3.22383 23.2444 3.0625 22.9106 3.0625 22.5625V16.9188C3.06312 16.6209 3.18192 16.3321 3.39937 16.0998L7.93188 11.2435C8.07508 11.0898 8.25678 10.9656 8.46352 10.8802C8.67025 10.7948 8.89674 10.7503 9.12625 10.75H12.25V21.25ZM39.8125 23.875C40.6247 23.875 41.4037 24.1516 41.978 24.6438C42.5523 25.1361 42.875 25.8038 42.875 26.5C42.875 27.1962 42.5523 27.8639 41.978 28.3562C41.4037 28.8484 40.6247 29.125 39.8125 29.125C39.0003 29.125 38.2213 28.8484 37.647 28.3562C37.0727 27.8639 36.75 27.1962 36.75 26.5C36.75 25.8038 37.0727 25.1361 37.647 24.6438C38.2213 24.1516 39.0003 23.875 39.8125 23.875ZM12.25 23.875C13.0622 23.875 13.8412 24.1516 14.4155 24.6438C14.9898 25.1361 15.3125 25.8038 15.3125 26.5C15.3125 27.1962 14.9898 27.8639 14.4155 28.3562C13.8412 28.8484 13.0622 29.125 12.25 29.125C11.4378 29.125 10.6588 28.8484 10.0845 28.3562C9.51015 27.8639 9.1875 27.1962 9.1875 26.5C9.1875 25.8038 9.51015 25.1361 10.0845 24.6438C10.6588 24.1516 11.4378 23.875 12.25 23.875Z"
                fill="#FFA600"
              />
            </svg>
          </div>
        </div>
        <div class="track-sign">
          <svg
            width="32"
            height="32"
            viewBox="0 0 32 32"
            fill="none"
            xmlns="http://www.w3.org/2000/svg"
          >
            <g filter="url(#filter0_d)">
              <circle
                cx="16"
                cy="12"
                r="12"
                transform="rotate(-90 16 12)"
                fill="#F7B643"
              />
            </g>
            <circle
              cx="16"
              cy="12"
              r="6"
              transform="rotate(-90 16 12)"
              fill="white"
            />
            <defs>
              <filter
                id="filter0_d"
                x="0"
                y="0"
                width="32"
                height="32"
                filterUnits="userSpaceOnUse"
                color-interpolation-filters="sRGB"
              >
                <feFlood flood-opacity="0" result="BackgroundImageFix" />
                <feColorMatrix
                  in="SourceAlpha"
                  type="matrix"
                  values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
                />
                <feOffset dy="4" />
                <feGaussianBlur stdDeviation="2" />
                <feColorMatrix
                  type="matrix"
                  values="0 0 0 0 0.980392 0 0 0 0 0.960784 0 0 0 0 0.894118 0 0 0 1 0"
                />
                <feBlend
                  mode="normal"
                  in2="BackgroundImageFix"
                  result="effect1_dropShadow"
                />
                <feBlend
                  mode="normal"
                  in="SourceGraphic"
                  in2="effect1_dropShadow"
                  result="shape"
                />
              </filter>
            </defs>
          </svg>
        </div>
      </div>
      <div class="relative">
        <div class="shipment-track flex justify-between items-center">
          <div>
            <p>Date</p>
          </div>
          <div class="text-center">
            <p class="text-2xl font-bold">In Transit</p>
            <p class="text-sm">Parcel has left the sorting facility</p>
          </div>
          <div>
            <svg
              width="49"
              height="32"
              viewBox="0 0 49 32"
              fill="none"
              xmlns="http://www.w3.org/2000/svg"
            >
              <path
                d="M49 4.1875C49 3.14321 48.516 2.14169 47.6545 1.40327C46.793 0.664843 45.6246 0.25 44.4062 0.25H16.8438C15.6254 0.25 14.457 0.664843 13.5955 1.40327C12.734 2.14169 12.25 3.14321 12.25 4.1875V8.125H9.12625C8.43798 8.12553 7.75866 8.25861 7.13846 8.51441C6.51827 8.77021 5.97306 9.1422 5.54313 9.60288L1.00756 14.4591C0.354977 15.1579 -0.000404358 16.0263 0 16.9214V22.5625C0 23.6068 0.483982 24.6083 1.34548 25.3467C2.20697 26.0852 3.37541 26.5 4.59375 26.5H6.125C6.125 27.8924 6.77031 29.2277 7.91897 30.2123C9.06763 31.1969 10.6255 31.75 12.25 31.75C13.8745 31.75 15.4324 31.1969 16.581 30.2123C17.7297 29.2277 18.375 27.8924 18.375 26.5H33.6875C33.6857 27.1998 33.8472 27.8928 34.1624 28.5383C34.4776 29.1839 34.9402 29.7688 35.523 30.2589C36.1058 30.749 36.797 31.1343 37.556 31.3921C38.315 31.6499 39.1264 31.775 39.9427 31.7601C40.7589 31.7453 41.5634 31.5907 42.309 31.3055C43.0545 31.0202 43.726 30.6101 44.2839 30.0993C44.8419 29.5884 45.275 28.9871 45.558 28.3307C45.8409 27.6742 45.9678 26.976 45.9314 26.2769C46.8285 26.0062 47.6056 25.5035 48.1552 24.8382C48.7049 24.1729 49.0001 23.3777 49 22.5625V4.1875ZM45.0371 23.7595C44.4834 22.9825 43.7034 22.3423 42.7736 21.902C41.8439 21.4616 40.7965 21.2361 39.7343 21.2478C38.6722 21.2594 37.6318 21.5078 36.7155 21.9684C35.7993 22.429 35.0386 23.0861 34.5083 23.875H17.5543C17.0155 23.0777 16.2427 22.4152 15.3125 21.9535V4.1875C15.3125 3.8394 15.4738 3.50556 15.761 3.25942C16.0482 3.01328 16.4376 2.875 16.8438 2.875H44.4062C44.8124 2.875 45.2018 3.01328 45.489 3.25942C45.7762 3.50556 45.9375 3.8394 45.9375 4.1875V22.5625C45.9377 22.8151 45.8529 23.0625 45.6932 23.2748C45.5335 23.4871 45.3057 23.6554 45.0371 23.7595ZM12.25 21.25C11.1749 21.25 10.1187 21.4926 9.18759 21.9534C8.2565 22.4142 7.48332 23.0769 6.94575 23.875H4.59375C4.18764 23.875 3.79816 23.7367 3.51099 23.4906C3.22383 23.2444 3.0625 22.9106 3.0625 22.5625V16.9188C3.06312 16.6209 3.18192 16.3321 3.39937 16.0998L7.93188 11.2435C8.07508 11.0898 8.25678 10.9656 8.46352 10.8802C8.67025 10.7948 8.89674 10.7503 9.12625 10.75H12.25V21.25ZM39.8125 23.875C40.6247 23.875 41.4037 24.1516 41.978 24.6438C42.5523 25.1361 42.875 25.8038 42.875 26.5C42.875 27.1962 42.5523 27.8639 41.978 28.3562C41.4037 28.8484 40.6247 29.125 39.8125 29.125C39.0003 29.125 38.2213 28.8484 37.647 28.3562C37.0727 27.8639 36.75 27.1962 36.75 26.5C36.75 25.8038 37.0727 25.1361 37.647 24.6438C38.2213 24.1516 39.0003 23.875 39.8125 23.875ZM12.25 23.875C13.0622 23.875 13.8412 24.1516 14.4155 24.6438C14.9898 25.1361 15.3125 25.8038 15.3125 26.5C15.3125 27.1962 14.9898 27.8639 14.4155 28.3562C13.8412 28.8484 13.0622 29.125 12.25 29.125C11.4378 29.125 10.6588 28.8484 10.0845 28.3562C9.51015 27.8639 9.1875 27.1962 9.1875 26.5C9.1875 25.8038 9.51015 25.1361 10.0845 24.6438C10.6588 24.1516 11.4378 23.875 12.25 23.875Z"
                fill="#FFA600"
              />
            </svg>
          </div>
        </div>
        <div class="track-sign">
          <svg
            width="32"
            height="32"
            viewBox="0 0 32 32"
            fill="none"
            xmlns="http://www.w3.org/2000/svg"
          >
            <g filter="url(#filter0_d)">
              <circle
                cx="16"
                cy="12"
                r="12"
                transform="rotate(-90 16 12)"
                fill="#F7B643"
              />
            </g>
            <circle
              cx="16"
              cy="12"
              r="6"
              transform="rotate(-90 16 12)"
              fill="white"
            />
            <defs>
              <filter
                id="filter0_d"
                x="0"
                y="0"
                width="32"
                height="32"
                filterUnits="userSpaceOnUse"
                color-interpolation-filters="sRGB"
              >
                <feFlood flood-opacity="0" result="BackgroundImageFix" />
                <feColorMatrix
                  in="SourceAlpha"
                  type="matrix"
                  values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
                />
                <feOffset dy="4" />
                <feGaussianBlur stdDeviation="2" />
                <feColorMatrix
                  type="matrix"
                  values="0 0 0 0 0.980392 0 0 0 0 0.960784 0 0 0 0 0.894118 0 0 0 1 0"
                />
                <feBlend
                  mode="normal"
                  in2="BackgroundImageFix"
                  result="effect1_dropShadow"
                />
                <feBlend
                  mode="normal"
                  in="SourceGraphic"
                  in2="effect1_dropShadow"
                  result="shape"
                />
              </filter>
            </defs>
          </svg>
        </div>
      </div>
      <div class="relative">
        <div class="shipment-track flex justify-between items-center">
          <div>
            <p>Date</p>
          </div>
          <div class="text-center">
            <p class="text-2xl font-bold">Dispatched</p>
            <p class="text-sm">Parcel has been collected by carrier</p>
          </div>
          <div>
            <svg
              width="49"
              height="32"
              viewBox="0 0 49 32"
              fill="none"
              xmlns="http://www.w3.org/2000/svg"
            >
              <path
                d="M49 4.1875C49 3.14321 48.516 2.14169 47.6545 1.40327C46.793 0.664843 45.6246 0.25 44.4062 0.25H16.8438C15.6254 0.25 14.457 0.664843 13.5955 1.40327C12.734 2.14169 12.25 3.14321 12.25 4.1875V8.125H9.12625C8.43798 8.12553 7.75866 8.25861 7.13846 8.51441C6.51827 8.77021 5.97306 9.1422 5.54313 9.60288L1.00756 14.4591C0.354977 15.1579 -0.000404358 16.0263 0 16.9214V22.5625C0 23.6068 0.483982 24.6083 1.34548 25.3467C2.20697 26.0852 3.37541 26.5 4.59375 26.5H6.125C6.125 27.8924 6.77031 29.2277 7.91897 30.2123C9.06763 31.1969 10.6255 31.75 12.25 31.75C13.8745 31.75 15.4324 31.1969 16.581 30.2123C17.7297 29.2277 18.375 27.8924 18.375 26.5H33.6875C33.6857 27.1998 33.8472 27.8928 34.1624 28.5383C34.4776 29.1839 34.9402 29.7688 35.523 30.2589C36.1058 30.749 36.797 31.1343 37.556 31.3921C38.315 31.6499 39.1264 31.775 39.9427 31.7601C40.7589 31.7453 41.5634 31.5907 42.309 31.3055C43.0545 31.0202 43.726 30.6101 44.2839 30.0993C44.8419 29.5884 45.275 28.9871 45.558 28.3307C45.8409 27.6742 45.9678 26.976 45.9314 26.2769C46.8285 26.0062 47.6056 25.5035 48.1552 24.8382C48.7049 24.1729 49.0001 23.3777 49 22.5625V4.1875ZM45.0371 23.7595C44.4834 22.9825 43.7034 22.3423 42.7736 21.902C41.8439 21.4616 40.7965 21.2361 39.7343 21.2478C38.6722 21.2594 37.6318 21.5078 36.7155 21.9684C35.7993 22.429 35.0386 23.0861 34.5083 23.875H17.5543C17.0155 23.0777 16.2427 22.4152 15.3125 21.9535V4.1875C15.3125 3.8394 15.4738 3.50556 15.761 3.25942C16.0482 3.01328 16.4376 2.875 16.8438 2.875H44.4062C44.8124 2.875 45.2018 3.01328 45.489 3.25942C45.7762 3.50556 45.9375 3.8394 45.9375 4.1875V22.5625C45.9377 22.8151 45.8529 23.0625 45.6932 23.2748C45.5335 23.4871 45.3057 23.6554 45.0371 23.7595ZM12.25 21.25C11.1749 21.25 10.1187 21.4926 9.18759 21.9534C8.2565 22.4142 7.48332 23.0769 6.94575 23.875H4.59375C4.18764 23.875 3.79816 23.7367 3.51099 23.4906C3.22383 23.2444 3.0625 22.9106 3.0625 22.5625V16.9188C3.06312 16.6209 3.18192 16.3321 3.39937 16.0998L7.93188 11.2435C8.07508 11.0898 8.25678 10.9656 8.46352 10.8802C8.67025 10.7948 8.89674 10.7503 9.12625 10.75H12.25V21.25ZM39.8125 23.875C40.6247 23.875 41.4037 24.1516 41.978 24.6438C42.5523 25.1361 42.875 25.8038 42.875 26.5C42.875 27.1962 42.5523 27.8639 41.978 28.3562C41.4037 28.8484 40.6247 29.125 39.8125 29.125C39.0003 29.125 38.2213 28.8484 37.647 28.3562C37.0727 27.8639 36.75 27.1962 36.75 26.5C36.75 25.8038 37.0727 25.1361 37.647 24.6438C38.2213 24.1516 39.0003 23.875 39.8125 23.875ZM12.25 23.875C13.0622 23.875 13.8412 24.1516 14.4155 24.6438C14.9898 25.1361 15.3125 25.8038 15.3125 26.5C15.3125 27.1962 14.9898 27.8639 14.4155 28.3562C13.8412 28.8484 13.0622 29.125 12.25 29.125C11.4378 29.125 10.6588 28.8484 10.0845 28.3562C9.51015 27.8639 9.1875 27.1962 9.1875 26.5C9.1875 25.8038 9.51015 25.1361 10.0845 24.6438C10.6588 24.1516 11.4378 23.875 12.25 23.875Z"
                fill="#FFA600"
              />
            </svg>
          </div>
        </div>
        <div class="track-sign">
          <svg
            width="32"
            height="32"
            viewBox="0 0 32 32"
            fill="none"
            xmlns="http://www.w3.org/2000/svg"
          >
            <g filter="url(#filter0_d)">
              <circle
                cx="16"
                cy="12"
                r="12"
                transform="rotate(-90 16 12)"
                fill="#F7B643"
              />
            </g>
            <circle
              cx="16"
              cy="12"
              r="6"
              transform="rotate(-90 16 12)"
              fill="white"
            />
            <defs>
              <filter
                id="filter0_d"
                x="0"
                y="0"
                width="32"
                height="32"
                filterUnits="userSpaceOnUse"
                color-interpolation-filters="sRGB"
              >
                <feFlood flood-opacity="0" result="BackgroundImageFix" />
                <feColorMatrix
                  in="SourceAlpha"
                  type="matrix"
                  values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
                />
                <feOffset dy="4" />
                <feGaussianBlur stdDeviation="2" />
                <feColorMatrix
                  type="matrix"
                  values="0 0 0 0 0.980392 0 0 0 0 0.960784 0 0 0 0 0.894118 0 0 0 1 0"
                />
                <feBlend
                  mode="normal"
                  in2="BackgroundImageFix"
                  result="effect1_dropShadow"
                />
                <feBlend
                  mode="normal"
                  in="SourceGraphic"
                  in2="effect1_dropShadow"
                  result="shape"
                />
              </filter>
            </defs>
          </svg>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import PageHeader from "../PageHeader.vue";
import SearchFilter from "../SearchFilter.vue";
export default {
  components: {
    PageHeader,
    SearchFilter,
  },
  mounted() {
    this.getShippingDetails();
  },
  methods: {
    async getShippingDetails() {
      const shippingId = this.$route.query.tracking_id;

      try {
        const response = await this.$_getSingleBooking(shippingId);
        this.log(response);
      } catch (error) {
        this.handleError(error);
      }
    },
  },
};
</script>

<style scoped>
.shipment-track {
  width: 90%;
  height: 20vh;
  background: #f0f0f0;
  border-radius: 10px;
  padding: 1rem;
  margin: 3rem 0 2rem auto;
  position: relative;
}
.tracks {
  border-left: 2px dashed #959cb6;
  margin: 5rem 2rem;
}
.tracks > div:first-of-type .track-sign {
  left: -0.8rem;
}
.track-sign {
  position: absolute;
  left: -1.1rem;
  top: 0;
}
</style>
